import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import dayjs from 'dayjs';
import { DayOfWeekEnum, dayOfWeekIso } from 'src/app/enums/day-of-week.enum';

@Component({
  selector: 'app-date-picker-dialog',
  templateUrl: './date-picker-dialog.component.html',
  styleUrl: './date-picker-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    FormsModule,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatDialogActions,
    MatButton,
  ],
})
export class DatePickerDialogComponent {
  dialogRef = inject<MatDialogRef<DatePickerDialogComponent>>(MatDialogRef);
  data = inject<DatePickerDialogData>(MAT_DIALOG_DATA);

  label: string | null;
  selected_date: Date | null;
  min_date: Date | null;

  constructor() {
    const data = this.data;

    this.label = data.label;
    this.min_date = data.min_date ?? null;
    this.selected_date = data.selected_date ?? null;
  }

  submit(): void {
    this.dialogRef.close(this.selected_date);
  }

  filter = (d: Date | null): boolean => {
    if (this.data.filter === null) {
      return true;
    }

    const day = dayjs(d || new Date()).isoWeekday();

    return day === dayOfWeekIso(this.data.filter);
  };
}

export interface DatePickerDialogData {
  dialog_title: string;
  dialog_ok_button: string;
  filter: DayOfWeekEnum | null;
  label: string;
  selected_date: Date | null;
  min_date: Date | null;
}
